import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setChangedFormItems } from "../employeeDetailsSlice";
import { getChangedItems } from "../../../components/util/helpers";
import { useIntl } from "react-intl";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import Spacer from "../../../components/layouts/Spacer";
var flatten = require("flat");

const FormWrapper = (props) => {
  const { mode, onSubmit, onFinishFailed, onDecline, saveLoading, children } =
    props;
  const [form] = Form.useForm();
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const changedItems = useSelector(
    (state) => state.employeeDetails.changedItems.changed
  );
  const intl = useIntl();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setChangedFormItems({ changed: [], values: [] }));
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue(
      flatten(
        {
          ...activeEmployee,
          is_professional_employee:
            activeEmployee.professional_role_id !== null,
        },
        {
          safe: true,
        }
      )
    );

    const activePeriod =
      activeEmployee &&
      activeEmployee.work_periods &&
      activeEmployee.work_periods.slice(-1)[0];
    if (activePeriod) {
      form.setFieldsValue({
        startEmployment: activePeriod.start,
        endEmployment: activePeriod.end,
      });
    }
  }, [activeEmployee, dispatch, form, mode]);

  const onValuesChange = (changedValues, allValues) => {
    let changedItemsArr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      activeEmployee
    );
    let updatedAllValues = { ...allValues };

    const { is_professional_employee, care_giver, staff_member } =
      changedValues;

    if (is_professional_employee === false) {
      const fieldsToNullify = [
        "professional_role_id",
        "professional_role_position_percentage",
      ];

      fieldsToNullify.forEach((field) => {
        form.setFieldValue(field, null);
        changedItemsArr.push(field);
        updatedAllValues[field] = null;
      });
    }

    if (care_giver !== undefined || staff_member !== undefined) {
      form.validateFields();
    }

    dispatch(
      setChangedFormItems({
        changed: changedItemsArr,
        values: updatedAllValues,
      })
    );
  };

  return (
    <Form
      scrollToFirstError
      layout="vertical"
      onFinish={onSubmit}
      onFinishFailed={onFinishFailed}
      onValuesChange={onValuesChange}
      form={form}
    >
      {children}
      <Spacer vertical={true} extra={true} />
      <FloatingFormActions
        resource={"employees"}
        action={"editor"}
        onCancel={onDecline}
        mode={mode}
        formName={activeEmployee.first_name}
        onDecline={onDecline}
        hideDelete={true}
        hideDecline={true}
        saveLoading={saveLoading}
        saveText={intl.formatMessage({
          id: "app.actions.saveChanges",
        })}
        disabled={changedItems.length === 0}
        show={changedItems.length > 0}
      />
    </Form>
  );
};

FormWrapper.propTypes = {
  mode: PropTypes.string,
  onSubmit: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FormWrapper;
